module.exports = __webpack_public_path__ + "img/20230803093847944q2g.39e02770.jpg";